import { writable, get } from 'svelte/store';

const STORAGE_KEY = 'theme';

function initialTheme(): 'light' | 'dark' {
	if (typeof localStorage !== 'undefined') {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (stored === 'light' || stored === 'dark') return stored;
	}
	if (typeof matchMedia !== 'undefined') {
		return matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
	}
	return 'light';
}

function applyTheme(value: 'light' | 'dark') {
	if (typeof document !== 'undefined') {
		const root = document.documentElement;
		root.classList.add('theme-transition');
		root.classList.toggle('dark', value === 'dark');
		window.setTimeout(() => root.classList.remove('theme-transition'), 260);
	}
}

export const theme = writable<'light' | 'dark'>(initialTheme());

theme.subscribe((value) => {
	applyTheme(value);
	if (typeof localStorage !== 'undefined') {
		localStorage.setItem(STORAGE_KEY, value);
	}
});

export function toggleTheme() {
	theme.update((value) => (value === 'dark' ? 'light' : 'dark'));
}

export function setTheme(value: 'light' | 'dark') {
	theme.set(value);
}
